import React, { useMemo } from 'react'
import { Card, CardContent, CardHeader, Box } from '@mui/material'
import DataAnalysisFilters from '../../components/DataAnalysisFilters/DataAnalysisFilters'
import { ScatterPlotChart } from 'components'
import { getTabByKey, prettyAttr, TAB_KEYS } from '../../utils/consts'
import EmptyState from 'pages/DataAnalysis/components/EmptyState'
import * as sxStyles from '../tabs.styles'
import { DataTabsLayout, TrendChartStatus } from '../../layouts'

export const SpectralImageComparison = () => {
  const mockScatterData = [
    {
      wheat: 'Wheat 1111',
      x: 50,
      y: 50,
      Protein: '0.5%',
      Moisture: '2%',
      'Wet Gluten': 27,
      STD: 3,
    },
    {
      wheat: 'Wheat 1111',
      x: 55,
      y: 55,
      Protein: '0.5%',
      Moisture: '2%',
      'Wet Gluten': 27,
      STD: 3,
    },
    {
      wheat: 'Wheat 2222',
      x: 10,
      y: 70,
      Protein: '0.8%',
      Moisture: '1.8%',
      'Wet Gluten': 25,
      STD: 2,
    },
    {
      wheat: 'Wheat 3333',
      x: 30,
      y: 80,
      Protein: '0.6%',
      Moisture: '2.2%',
      'Wet Gluten': 28,
      STD: 4,
    },
    {
      wheat: 'Wheat 4444',
      x: 10,
      y: 130,
      Protein: '0.5%',
      Moisture: '2%',
      'Wet Gluten': 27,
      STD: 3,
    },
    // ...trimmed for brevity
  ]

  const scatterSeries = [
    { key: 'Wheat 1111', name: 'Wheat 1111', color: '#a83232' },
    { key: 'Wheat 2222', name: 'Wheat 2222', color: '#c06060' },
    { key: 'Wheat 3333', name: 'Wheat 3333', color: '#6d1f1f' },
    { key: 'Wheat 4444', name: 'Wheat 4444', color: '#8a4d4d' },
  ]

  const currentTab = getTabByKey(TAB_KEYS.SPECTRAL_IMAGE_COMPARISON)
  const rows = useMemo(() => mockScatterData, [])
  const hasAnyData = rows.length > 0

  return (
    <DataTabsLayout
      sidebar={
        <DataAnalysisFilters
          filtersList={currentTab?.filters ?? []}
          chartKey={TAB_KEYS.SPECTRAL_IMAGE_COMPARISON}
        />
      }
    >
      <TrendChartStatus
        status="succeeded"
        title={TAB_KEYS.SPECTRAL_IMAGE_COMPARISON}
      >
        {!hasAnyData ? (
          <EmptyState />
        ) : (
          <Box display="flex" justifyContent="center" width="100%">
            <Card
              data-exportable-chart="true"
              variant="outlined"
              sx={{
                ...sxStyles.parametersComparisonCard,
                width: '100%',
                maxWidth: 800,
              }}
            >
              <CardHeader
                title={prettyAttr('Spectral Image Comparison')}
                titleTypographyProps={{ fontSize: 24, fontWeight: 600 }}
              />
              <CardContent
                sx={{
                  ...sxStyles.parametersComparisonCardContent,
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <ScatterPlotChart
                    data={rows}
                    series={scatterSeries}
                    categoryKey="wheat"
                    xDataKey="x"
                    yDataKey="y"
                  />
                </Box>
              </CardContent>
            </Card>
          </Box>
        )}
      </TrendChartStatus>
    </DataTabsLayout>
  )
}
